import React from 'react';

const Logo = () => {
  return (
    <svg
      width="90.78"
      height="47.7400016784668"
      xmlns="http://www.w3.org/2000/svg"
      title="CodingCoach logo"
    >
      <g>
        <rect
          fill="none"
          id="canvas_background"
          height="49.74"
          width="92.78"
          y="-1"
          x="-1"
        />
      </g>
      <g>
        <g id="svg_1" fill="none">
          <g id="svg_2">
            <polygon
              id="svg_3"
              points="57.11775207519531,6.389999866485596 74.5977554321289,23.8700008392334 57.11775207519531,41.349998474121094 63.50775909423828,47.7400016784668 87.37775421142578,23.8700008392334 63.50775909423828,0 "
              fill="#69D5B1"
            />
            <path
              id="svg_4"
              d="m54.42776,41.35l-17.47,-17.48l17.47,-17.48l-6.39,-6.39l-17.48,17.48l0,0l-6.39,6.39l0,0l-4,4c-1.63008,1.63049 -4.08186,2.11842 -6.21198,1.23625c-2.13012,-0.88217 -3.51904,-2.96068 -3.51904,-5.26625c0,-2.30557 1.38892,-4.38408 3.51904,-5.26625c2.13012,-0.88217 4.5819,-0.39424 6.21198,1.23625l2,2l6.4,-6.39l-2,-2c-4.215,-4.21723 -10.55555,-5.47974 -16.06446,-3.19873c-5.50892,2.28102 -9.10105,7.65625 -9.10105,13.61873c0,5.96248 3.59213,11.33771 9.10105,13.61873c5.50891,2.28101 11.84946,1.0185 16.06446,-3.19873l4,-4l17.48,17.48l6.38,-6.39z"
              fill="#69D5B1"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Logo;
